module.exports = __webpack_public_path__ + "producr-dried fresh-grass-11.jpg?648e8fee8e54d7e9c01158499c432b98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/producr-dried fresh-grass-11.jpg
// module id = 69
// module chunks = 0